/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { SelfAssessDto, SelfAssessService,  SystemDateDisplayFormat } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'

import moment from 'moment'
import clsx from 'clsx'



const SelfSettingPage: FC = () => {
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<SelfAssessDto[]>([])

    const columnDef: ColDef<SelfAssessDto>[] = [
        {
            label: 'Id',
            renderItem: ({item}) => item.id,
            hidden: true
        },
        {
            label: 'ชื่อ',
            renderItem: ({item}) => item.title,
        },
        {
            label: 'ประเภท',
            renderItem: ({item}) => {
                switch (item.category) {
                    case 'Late':
                        return <>{'มาสาย'}</>
                    case 'Leave':
                        return <>{'ลา'}</>
                    case 'Issue':
                        return <>{'แฟ้ม'}</>
                    case 'Stat':
                        return <>{'สถิติ'}</>
                    default:
                        return <></>
                }
            }
        },
        {
            label: 'คะแนน',
            renderItem: ({item}) =>  item.point
        },

        {
            label: '',
            renderItem: ({item}) => <>
                <div className='text-center'>
                    <button
                        type='button'
                        onClick={(e) => {
                            navigate('/setting/self/' + item.id)
                        }
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3'
                        />
                    </button>


                </div>
            </>,
        },
    ]

    const tableSetting: TableSetting<SelfAssessDto> = {
        showColAction: false,
        primaryKey: (item: SelfAssessDto) => item,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: false,
        showFilter: false,
        showSearch: false,
        btnAddText: '',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/setting/self/new')
    }

    useEffect(() => {
        const load = () => {
            SelfAssessService.GetSelfAssesssSetting().then((result) => {
                const row = result.data.result
                setData(row)
            })
        }
        load()
    }, [reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>

                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div >
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data}
                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { SelfSettingPage }
